import _regeneratorRuntime from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { isOwnedByContext } from '../helpers/is-owned-by-context';
export var createChannelSplitterNodeRendererFactory = function createChannelSplitterNodeRendererFactory(createNativeChannelSplitterNode, getNativeAudioNode, renderInputsOfAudioNode) {
  return function () {
    var renderedNativeAudioNodes = new WeakMap();

    var createAudioNode = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(proxy, nativeOfflineAudioContext, trace) {
        var nativeAudioNode, nativeAudioNodeIsOwnedByContext, options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nativeAudioNode = getNativeAudioNode(proxy); // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.

                nativeAudioNodeIsOwnedByContext = isOwnedByContext(nativeAudioNode, nativeOfflineAudioContext);

                if (!nativeAudioNodeIsOwnedByContext) {
                  options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfOutputs: nativeAudioNode.numberOfOutputs
                  };
                  nativeAudioNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, options);
                }

                renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
                _context.next = 6;
                return renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode, trace);

              case 6:
                return _context.abrupt("return", nativeAudioNode);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function createAudioNode(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      render: function render(proxy, nativeOfflineAudioContext, trace) {
        var renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);

        if (renderedNativeAudioNode !== undefined) {
          return Promise.resolve(renderedNativeAudioNode);
        }

        return createAudioNode(proxy, nativeOfflineAudioContext, trace);
      }
    };
  };
};